import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SkillQueryResult } from '../models/skill-search-result';
import { ApiConstants } from '../../shared/constants/api-constants';

@Injectable({ providedIn: 'root' })
export class SkillSearchService {
  constructor(private http: HttpClient) { }
  searchSkillsPaged(payload: any): Observable<SkillQueryResult> {
    return this.http.post<SkillQueryResult>(ApiConstants.Skill_Search_Api, payload);
  }

}
